import type { FormZone } from '@painpal/contracts';
import { formatSigned, formatWhole } from '../../lib/format';
import { CountUp } from '../../ui/CountUp';
import { weekNote, type TodayStats } from './fitnessStats';
import { ZONE_LABELS } from './headline';
import styles from './fitness.module.css';

interface CellProps { label: string; value: number; format: (n: number) => string; note: string; zone?: FormZone }

function Cell({ label, value, format, note, zone }: CellProps) {
  return (
    <div className={styles.stripCell}>
      <dt className={styles.stripLabel}>{label}</dt>
      <dd className={styles.stripValue} data-zone={zone}><CountUp value={value} format={format} /></dd>
      <dd className={styles.stripNote}>{note}</dd>
    </div>
  );
}

export function TodayStrip({ stats }: { stats: TodayStats }) {
  const { today, weekAgo, zone } = stats;
  return (
    <dl className={styles.strip} aria-label="Today">
      <Cell label="FITNESS" value={today.fitness} format={formatWhole} note={weekNote(today.fitness, weekAgo?.fitness)} />
      <Cell label="FATIGUE" value={today.fatigue} format={formatWhole} note={weekNote(today.fatigue, weekAgo?.fatigue)} />
      <Cell label="FORM" value={today.form} format={formatSigned} note={ZONE_LABELS[zone]} zone={zone} />
    </dl>
  );
}
